/**
 * LlmServiceStandalone — STUB; standalone host has no LLM.
 *
 * Standalone-mode degradation per planner §M3 risk #4: the downloadable
 * HTML bundle has no backend, so LLM features are disabled with a
 * graceful banner. isAvailable returns false; chat throws.
 *
 * No M4 work changes this — the standalone variant is permanently
 * LLM-less by design (the user runs it without a backend on purpose).
 */
import type { ChatMessage, LlmService } from '../types';
import { ServiceUnavailableError } from '../types';

export class LlmServiceStandalone implements LlmService {
  isAvailable(): boolean {
    return false;
  }

  async chat(_messages: ChatMessage[]): Promise<string> {
    throw new ServiceUnavailableError(
      'LlmServiceStandalone.chat',
      'standalone_host_has_no_llm',
    );
  }
}
